import React from 'react';
import '../../assets/styles/Navbar.css';

const LeftSidebar = () => {
    return (
        <div className="sidebar hover-sidebar">
            <ul className="menu">
                <li>Settings</li>
                <li>Reception</li>
                <li>Nursing</li>
                <li>Doctors</li>
                <li>Insurance</li>
                <li>Reports</li>
                <li>Data Science</li>
                <li>Info Center</li>
            </ul>
        </div>
    );
};

export default LeftSidebar;
